import React, { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { asFetchableBlock, useBlockContext, useRefreshBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, OptionalEditView, Views } from '../../types/BlockWithViews';
import { AppLibraryPersonalDefaultView } from './views/AppLibraryPersonalDefaultView';
import { Namespace } from '../../translation/namespace';
import {
  BlockInteractions,
  createButtonObject,
  DISPLAY_TYPE,
  Views as BlockInteractionsViews,
} from '../../components/organisms/BlockInteractions';
import { Icons } from '../../components/atoms/SVG';
import { AppLibraryPersonalEditView } from './views/AppLibraryPersonalEditView';
import { HeadingHierarchy } from '../../_lib/components/Heading/Heading';

type AppLibraryPersonalBlockProps = Views<
  DefaultView<AppLibraryPersonalDefaultView> & OptionalEditView<AppLibraryPersonalEditView>
>;

function AppLibraryPersonal({ views, activeView = 'default' }: AppLibraryPersonalBlockProps) {
  const { t } = useTranslation(Namespace.AppLibraryPersonal);
  const { elementType, uuid } = useBlockContext();
  const { refreshCount } = useRefreshBlock();
  const headline: { text: string, hierarchy: HeadingHierarchy, visible: boolean } = {
    text: t('headline'),
    hierarchy: 4,
    visible: true,
  };

  const createButtonsObject = () => {
    return (
      views.edit &&
      createButtonObject(
        BlockInteractionsViews.EDIT,
        Icons.EDIT_PENCIL,
        `${Namespace.AppLibraryPersonal}:edit`,
        DISPLAY_TYPE.COLLAPSIBLE,
        <AppLibraryPersonalEditView {...views.edit} />,
      )
    );
  };
  return (
    <BlockInteractions
      key={refreshCount}
      refreshCount={refreshCount}
      headline={headline}
      views={views}
      activeView={activeView}
      buttons={createButtonsObject()}
      uuid={uuid}
      elementType={elementType}
    >
      <AppLibraryPersonalDefaultView {...views.default} />
    </BlockInteractions>
  );
}

export const AppLibraryPersonalBlock = asFetchableBlock(AppLibraryPersonal, BlockType.applibraryPersonal);
export type AppLibraryPersonalBlock = ComponentProps<typeof AppLibraryPersonalBlock>;
